import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Loader from "./Loader";
import { ToastContainer } from "react-toastify";

import "../assets/css/Layout.scss";
import "react-toastify/dist/ReactToastify.css";

const Layout = (props) => {
  return (
    <>
      {props.loading && <Loader />}
      <ToastContainer />
      <Header />
      <div className="content">{props.children}</div>
      <Footer />
    </>
  );
};

export default Layout;
